import { O, R, RA } from "@scripts/fp-ts";
import { SitesJumpLink } from "@scripts/react/components/SidebarLinks";

type GenRelatedContent = Record<string, ReadonlyArray<unknown> | O.Option<unknown>>;

export const relatedContent = (rc: GenRelatedContent): SitesJumpLink =>
  SitesJumpLink("Related Content", [], {
    hidden: R.toEntries(rc).every(([, v]) => RA.is(v) ? v.length === 0 : O.isNone(v)),
  });
